import { ChangeDetectionStrategy, Component, inject, linkedSignal, viewChild } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TemplateCriteriaStore } from '../store/template-criteria.store';
import { injectParams } from 'ngxtension/inject-params';
import { TemplateCriteriaEnableService } from './template-criteria-enable.service';
import { EnableEntityComponent } from '@r1-compass-library/components/enable-entity/enable-entity.component';
import { EnableSaveGuardWarning } from '@r1-compass-library/guards/save-guards/enable.guard';

@Component({
    selector: 'r1-compass-app-template-criteria-enable',
    imports: [EnableEntityComponent],
    template: `
        <r1-compass-lib-enable-entity
            [currentEnableStatus]="currentEnableStatus()"
            [copyHeader]="'Enable for Play Use'"
            [entityType]="'Template Criteria'"
            (save)="onSave()"
            (toggleChange)="onToggleChange($event)">
            Toggle “Enabled” to allow plays to use this Template Criteria or “Disabled” to prevent this Template
            Criteria from being used. The Template Criteria must not be in use by any active Plays to be disabled.
        </r1-compass-lib-enable-entity>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [TemplateCriteriaEnableService],
})
export class TemplateCriteriaEnableComponent implements EnableSaveGuardWarning {
    readonly #store = inject(TemplateCriteriaStore);
    readonly #enableService = inject(TemplateCriteriaEnableService);

    protected currentEnableStatus = linkedSignal<boolean | undefined>(() => this.#store.template()?.enabled);

    public enableComponentSpy = viewChild.required(EnableEntityComponent);

    private templateId = injectParams<string | null>('id');

    constructor() {
        const templateId = this.templateId();
        if (templateId && templateId !== 'new' && this.#store.template()?.id !== +templateId) {
            this.#store.getTemplate(+templateId);
        }
    }

    public onSave() {
        return this.#enableService.save(this.currentEnableStatus());
    }

    protected async onToggleChange(event: MatSlideToggleChange) {
        const tc = this.#store.template();
        if (!tc) {
            return;
        }

        const outcome = event.checked ? await this.#enableService.enable() : await this.#enableService.disable(tc);

        if (outcome.status === 'success') {
            this.currentEnableStatus.set(outcome.value.shouldSetEnabled);
            event.source.checked = outcome.value.shouldSetEnabled;
        }
    }
}
